import { Range } from 'slate';

import { BaseAction } from './utils/baseAction';

export type EditLinkEditorMenuAction = BaseAction<'editLinkEditorMenu', Range>;

export const editLinkEditorMenu = (selection: Range): EditLinkEditorMenuAction => ({
  type: 'editLinkEditorMenu',
  payload: selection,
});
